import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { TxCoordinatorApiActions } from "../actions/action-index";
import { TxCoordinator } from "./tx-coordinator";

export const featureKey = "treatmentCoordinators";

export type TxCoordinatorState = EntityState<TxCoordinator>

export const adapter = createEntityAdapter<TxCoordinator>({
  selectId: (txCoordinator) => txCoordinator.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export const initialState: TxCoordinatorState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(TxCoordinatorApiActions.loadSuccess, (state, { txCoordinators }) => ({
    ...adapter.setAll(
      txCoordinators.map((g) => ({
        name: g.Name,
        id: g.PracticeStaffId,
      })),
      state
    ),
  }))
);
